// extracted by mini-css-extract-plugin
export default {"carousel_main":"Carousel_carousel_main__5+o2l","carousel_next_btn":"Carousel_carousel_next_btn__u2hP0","carousel_prev_btn":"Carousel_carousel_prev_btn__POdFc"};